<style lang="less" scoped>
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    li{
        list-style: none;
    }
    .moreVipServer{
        .topBg{
            width: 100%;
            height: 200px;
            background-size: 100% 100%;
            font-size: 16px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .introduction{
            margin-top: 45px;
            .intTitle{
                .title{
                    font-size: 25px;
                    font-weight: bold;
                    color: #333;
                }
                >div{
                    width: 36px;
                    height: 1.5px;
                    margin: 3px auto 7px;
                    background-color: #F36800;
                }
                .enTitle{
                    color: #B5B5B5;
                    letter-spacing:1.5px;
                }
            }
            ul{
                max-width: 1440px;
                width: 100%;
                margin: 0 auto;
                padding: 50px 0 0;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                @media screen and (max-width: 720px) {
                    li.vip-service-item.vip-service-items {
                        width: 338px;
                        margin: 0 auto 60px auto;
                    }
                }
                @media screen and (max-width: 1024px) {
                    li.vip-service-item {
                        width: 50%;
                    }
                }
                li{
                    width: 33.3%;
                    margin-bottom: 60px;
                    >div{
                        width: 338px;
                        height: 280px;
                        padding: 0 49px 30px;
                        background-color: #fcfcfc;
                        box-shadow: 0px 5px 20px rgba(151, 151, 151, 0.16); 
                        border-radius: 15px;
                        margin: 0 auto;
                        .iconImg{
                            margin: 0 auto;
                            position: relative;
                            top: -20px;
                        }
                        .tip{
                            font-size: 18px;
                            color: #000;
                            font-weight: bold;
                            margin: 0 0 12px;
                        }
                        .eveInt{
                            font-size: 16px;
                            color: #333;
                            text-align: left;
                            // white-space: pre-wrap;
                        }
                    }
                    
                }
            }
        }
    }
</style>
<template>
  <div class="moreVipServer">
    <div class="topBg" :style="{background:'url('+Back+')'}">
        <div>
            <span>基于行业大数据，我们每天都在进步</span>
        </div>
    </div>
    <div class="introduction">
        <div class="intTitle">
            <p class="title">云工厂消费者服务</p>
            <div></div>
            <p class="enTitle">Value&nbsp;added&nbsp;service&nbsp;of&nbsp;cloud&nbsp;warehouse&nbsp;members</p>
        </div>
        <ul>
            <li v-for="item in list" :key="item.id" class="vip-service-item vip-service-items">
                <div>
                    <div class="iconImg"><img :src="item.icon" alt=""></div>
                    <p class="tip">{{item.title}}</p>
                    <p class="eveInt">{{item.content}}</p>
                </div>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            Back:require('../../assets/moreVipServerBG.png'),
            list:[
                {
                    id:1,
                    icon:require('../../assets/moreVipIcon1.png'),
                    title:'免费设计',
                    content:'平台设计师/拆单师在线，根据需求，量身定制。'
                },{
                    id:2,
                    icon:require('../../assets/moreVipIcon2.png'),
                    title:'免费测量',
                    content:'服务点遍布全国，随时上门，免费测量。'
                },{
                    id:3,
                    icon:require('../../assets/moreVipIcon3.png'),
                    title:'一定省钱',
                    content:'材料厂家直供，工厂直接生产，省去了两道中键环节，成本更低。'
                },{
                    id:4,
                    icon:require('../../assets/moreVipIcon4.png'),
                    title:'品质保障',
                    content:'原材料由柜柜云仓、门窗云仓提供。材料全流程信息化，可以溯源。'
                },{
                    id:5,
                    icon:require('../../assets/moreVipIcon5.png'),
                    title:'长期售后',
                    content:'服务网点就在身边，工厂就在当地，平台监管，确保长期售后。'
                },{
                    id:6,
                    icon:require('../../assets/moreVipIcon6.png'),
                    title:'节约时间',
                    content:'服务网络化，沟通快；全国本地化，交货快。一切为了您宝贵的时间。'
                },
            ]
        }
    }
}
</script>


